
// eslint-disable-next-line
require('string.prototype.startswith') // Basically adds IE support

// Font Awesome packages
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
// import { faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { faMap, faFileChartLine, faFilter, faBarcodeAlt, faTimesCircle, faChevronUp, faChevronDown, faLocation, faFilePdf } from '@fortawesome/pro-light-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Vue from 'vue'
Vue.component('FontAwesomeIcon', FontAwesomeIcon)

// 
library.add( faInfoCircle, faMap, faFileChartLine, faFilter, faBarcodeAlt, faTimesCircle, faChevronUp, faChevronDown, faLocation, faFilePdf )

 